var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asset-association-item-content",domProps:{"innerHTML":_vm._s(_vm.assetData.question)}})}
var staticRenderFns = []

export { render, staticRenderFns }